import React from 'react';
import { IDependencies } from './interfaces/IDependencies';

export const DependenciesContext = React.createContext<IDependencies | null>(null);
